// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/index.css
// module id = njn1
// module chunks = 1